import { AttributeTextValue, Cart } from '@msdyn365-commerce/retail-proxy';
import { AttributeTextValueClass } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { ICartState } from '@msdyn365-commerce/global-state';

const addAttributeToCart = (attrKey: string, attrValue: string, cart: Cart): Cart => {
    const _cart = { ...cart };
    const attributeArray = _cart.AttributeValues || [];
    const attributeObj = {
        '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue',
        Name: attrKey,
        ExtensionProperties: [],
        TextValue: attrValue,
        TextValueTranslations: []
    };
    const attrIdx = attributeArray.findIndex(a => a.Name?.toUpperCase() === attrKey.toUpperCase());

    //Update existing attribute if there.
    if (attrIdx > -1) {
        (attributeArray[attrIdx] as AttributeTextValueClass).TextValue = attrValue;
    } else {
        attributeArray.push(attributeObj);
    }

    _cart.AttributeValues = attributeArray;

    return _cart;
};

const removeAttributeFromCart = (attrKey: string, cart: Cart): Cart => {
    const _cart = { ...cart };
    const attributeArray = _cart.AttributeValues || [];
    const attrIdx = attributeArray.findIndex(a => a.Name?.toUpperCase() === attrKey.toUpperCase());

    //We can't remove attribute values for some reason, so we'll just set the value to ''
    if (attrIdx > -1) {
        (attributeArray[attrIdx] as AttributeTextValueClass).TextValue = '';
    }
    _cart.AttributeValues = attributeArray;
    return _cart;
};

const getAttributeByKey = (cart: Cart, key: string): AttributeTextValue | null => {
    return cart.AttributeValues?.find(attribute => attribute.Name === key) ?? null;
};

const removeWarehouseAttributes = async (
    cart: ICartState,
    authorizedWarehouseAccounts: string[],
    isAlternateWarehouseFeatureEnabled: boolean,
    customerAccNum: string | undefined
): Promise<void> => {
    if (!cart || !cart.cart || !cart.cart.CartLines) {
        return;
    }

    const cartlines = cart.cart.CartLines;
    if (cartlines.length === 0 || cart.hasInvoiceLine) {
        return;
    }
    const hasAccess = isAlternateWarehouseFeatureEnabled || (customerAccNum && authorizedWarehouseAccounts.includes(customerAccNum));

    if (hasAccess) {
        return;
    }

    let changesMade = false;
    const updatedCartLines = cartlines.map(cartline => {
        let needsUpdate = false;
        const updatedAttributes = cartline.AttributeValues?.map((attr: AttributeTextValue) => {
            if (attr.Name === 'IsWarehouseOverride' && attr.TextValue !== 'false') {
                needsUpdate = true;
                return { ...attr, TextValue: 'false' };
            } else if (attr.Name === 'WarehouseId' && attr.TextValue !== '') {
                needsUpdate = true;
                return { ...attr, TextValue: '' };
            }
            return attr;
        });

        if (needsUpdate) {
            changesMade = true;
            return { ...cartline, AttributeValues: updatedAttributes };
        }
        return cartline;
    });

    if (!changesMade) {
        return;
    }

    try {
        await cart.updateCartLines({ updatedCartLinesObject: updatedCartLines });
    } catch (e) {
        console.error('Error removing warehouse attributes', e);
    }
};

export { addAttributeToCart, removeAttributeFromCart, removeWarehouseAttributes, getAttributeByKey };
